// extracted by mini-css-extract-plugin
export default {"box":"index_box_0ALF3","title":"index_title_0YNIV"};